import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";

import {
  FormControl,
  FormControlLabel,
  FormGroup,
  Checkbox,
} from "@material-ui/core";

import { useTranslation } from "react-i18next";

const WeekDaySelector = (props) => {
  const { t } = useTranslation();

  const [isMondaySelected, setIsMondaySelected] = useState(false);
  const [isTuesdaySelected, setIsTuesdaySelected] = useState(false);
  const [isWednesdaySelected, setIsWednesdaySelected] = useState(false);
  const [isThursdaySelected, setIsThursdaySelected] = useState(false);
  const [isFridaySelected, setIsFridaySelected] = useState(false);
  const [isSaturdaySelected, setIsSaturdaySelected] = useState(false);
  const [isSundaySelected, setIsSundaySelected] = useState(false);

  useEffect(() => {
    const arr = [];

    if (isMondaySelected) arr.push(1);
    if (isTuesdaySelected) arr.push(2);
    if (isWednesdaySelected) arr.push(3);
    if (isThursdaySelected) arr.push(4);
    if (isFridaySelected) arr.push(5);
    if (isSaturdaySelected) arr.push(6);
    if (isSundaySelected) arr.push(7);

    props.onChange(arr);
  }, [
    isMondaySelected,
    isTuesdaySelected,
    isWednesdaySelected,
    isThursdaySelected,
    isFridaySelected,
    isSaturdaySelected,
    isSundaySelected,
  ]);

  return (
    <FormControl component="fieldset">
      <FormGroup aria-label="position" row>
        <FormControlLabel
          value={isMondaySelected}
          onChange={(e) => setIsMondaySelected(e.target.checked)}
          control={<Checkbox />}
          label={t("mon")}
          labelPlacement="top"
        />
        <FormControlLabel
          value={isTuesdaySelected}
          onChange={(e) => setIsTuesdaySelected(e.target.checked)}
          control={<Checkbox />}
          label={t("tue")}
          labelPlacement="top"
        />
        <FormControlLabel
          value={isWednesdaySelected}
          onChange={(e) => setIsWednesdaySelected(e.target.checked)}
          control={<Checkbox />}
          label={t("wed")}
          labelPlacement="top"
        />
        <FormControlLabel
          value={isThursdaySelected}
          onChange={(e) => setIsThursdaySelected(e.target.checked)}
          control={<Checkbox />}
          label={t("thu")}
          labelPlacement="top"
        />
        <FormControlLabel
          value={isFridaySelected}
          onChange={(e) => setIsFridaySelected(e.target.checked)}
          control={<Checkbox />}
          label={t("fri")}
          labelPlacement="top"
        />
        <FormControlLabel
          value={isSaturdaySelected}
          onChange={(e) => setIsSaturdaySelected(e.target.checked)}
          control={<Checkbox />}
          label={t("sat")}
          labelPlacement="top"
        />
        <FormControlLabel
          value={isSundaySelected}
          onChange={(e) => setIsSundaySelected(e.target.checked)}
          control={<Checkbox />}
          label={t("sun")}
          labelPlacement="top"
        />
      </FormGroup>
    </FormControl>
  );
};

WeekDaySelector.propTypes = {
  onChange: PropTypes.function,
};

export default WeekDaySelector;



// WEBPACK FOOTER //
// ./src/components/WeekDaySelector.js